import './story.css'
export default function Story({ stories , showstory }) {
    return (
        <div className="stories">
            <ul>
          {stories.map(story => (
            <li key={story.id}>
              <div onClick={() => showstory(story.id)} className="storybanner" style={{background: story.colorbanner}}>
                <p style={{color: story.colormatn}}>{story.banner}</p>
              </div>
              <div className="storytitle"><p>{story.title}</p></div>
            </li>
            ))}
            </ul>
        </div>
      );
}